export const Endpoints = {
    CHECK_USER: "/api/auth/check-user",
    REGISTER_USER: "/api/auth/register",
    LOGIN_USER: "/api/auth/login",
    EXCHANGE_GITHUB_TOKEN: "/api/auth/exchange-github-code",
    REFRESH_TOKEN: "/api/auth/refresh",
    GET_TEAM: "/api/team",
    CREATE_TEAM: "/api/team/create",
    LEAVE_TEAM: "/api/team/leave",
    JOIN_TEAM: "/api/team/join",
    GET_PROBLEMS: "/api/problems",
    GET_PROBLEM_DETAILS: "/api/problems",
    GET_API_TOKEN: "/api/api-token",
    REFRESH_API_TOKEN: "/api/refresh-api-token",
    INDIVIDUAL_LEADERBOARD: "/api/leaderboard/individual",
    TEAM_LEADERBOARD: "/api/leaderboard/team",
    UPLOAD_CODE: "/files/api/submissions/code-upload-with-token"
}